import { TFunction } from "i18next";

type PartnerType = "SALES" | "PURCHASE";

const partnerTypeBaseMap: Record<PartnerType, Record<string, string>> = {
  SALES: {
    purchaseOrder: "order",
    purchaseOrderItems: "orderItems",
  },
  PURCHASE: {
    order: "purchaseOrder",
    orderItems: "purchaseOrderItems",
  },
};

const partnerTypeFullMap: Record<PartnerType, Record<string, string>> = {
  SALES: {
    purchaseOrder: "order",
    purchaseOrderItems: "orderItems",
  },
  PURCHASE: {
    order: "purchaseOrder",
    orderItems: "purchaseOrderItems",
  },
};

// i18nUtils.ts
export const translateWithPartnerType = (
  t: TFunction,
  fullKey: string,
  partnerType?: string,
): string => {
  const [baseKey, subKey] = fullKey.split(".");

  const map = partnerTypeFullMap[partnerType as PartnerType];

  const mappedBase =
    map && Object.prototype.hasOwnProperty.call(map, baseKey) ? map[baseKey] : baseKey;

  const mappedSub = map && Object.prototype.hasOwnProperty.call(map, subKey) ? map[subKey] : subKey;

  return t(`${mappedBase}.${mappedSub}`);
};
